var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIwamfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5557 9.0911L18.4605 9.10537V9.2016V20.1981V20.3098H18.5723H33.1734H33.2851V20.1981V7.01141V6.88166L33.1568 6.90091L18.5557 9.0911ZM32.149 19.1737H19.5966V10.0738L32.149 8.23578V19.1737Z",
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.223489
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1407 20.3349V20.4466H6.25244H17.6595H17.7713V20.3349V9.29279V9.16329L17.6432 9.18225L6.23608 10.8705L6.1407 10.8846V10.9811V20.3349ZM7.27676 19.3106V11.8532L16.6352 10.4717V19.3106H7.27676Z",
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.223489
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4605 31.9246V32.0208L18.5557 32.0351L33.1568 34.2253L33.2851 34.2445V34.1148V21.2475V21.1358H33.1734H18.5723H18.4605V21.2475V31.9246ZM19.5966 22.2718H32.149V32.9355L19.5966 31.0526V22.2718Z",
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.223489
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1407 30.1451V30.2415L6.23608 30.2556L17.6432 31.9439L17.7713 31.9629V31.8334V21.2475V21.1358H17.6595H6.25244H6.1407V21.2475V30.1451ZM7.27676 22.2718H16.6352V30.6544L7.27676 29.2729V22.2718Z",
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.223489
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0122 26.7542L25.5421 30.2841C25.7182 30.4602 26.0037 30.4602 26.1798 30.2841L33.9861 22.4778",
    stroke: "#EB5424",
    strokeWidth: 1.20372,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwamfa);
export default __webpack_public_path__ + "static/media/IWA MFA.2c39fdb2763bf09c001e13b611a1bf15.svg";
export { ForwardRef as ReactComponent };